import UsersTabs from './UsersTabs';

export default UsersTabs;
export * from './UsersTabs';
